import {Companies, Superstars} from "./models.js";

function TradeOffer() {

    // Integer
    const duration = null;

    // Foreign keys
    const senderCompanyId = null;
    const receiverCompanyId = null;

    return {
        duration,
        senderCompanyId,
        receiverCompanyId,
    };
}

function getTradeOfferSenderCompany(tradeOffer) {
    return Companies.find({'$loki': tradeOffer.senderCompanyId})[0];
}

function getTradeOfferReceiverCompany(tradeOffer) {
    return Companies.find({'$loki': tradeOffer.receiverCompanyId})[0];
}

function addTradeOfferOfferedSuperstars(tradeOffer, superstars) {
    superstars.forEach(c => {
        c.offeredTradeOfferId = tradeOffer.$loki
    });
}

function removeTradeOfferOfferedSuperstars(tradeOffer, superstars) {
    superstars.forEach(c => {
        c.offeredTradeOfferId = null
    });
}

function getTradeOfferOfferedSuperstars(tradeOffer) {
    return Superstars.find({'offeredTradeOfferId': tradeOffer.$loki});
}

function addTradeOfferRequestedSuperstars(tradeOffer, superstars) {
    superstars.forEach(c => {
        c.requestedTradeOfferId = tradeOffer.$loki
    });
}

function removeTradeOfferRequestedSuperstars(tradeOffer, superstars) {
    superstars.forEach(c => {
        c.requestedTradeOfferId = null
    });
}

function getTradeOfferRequestedSuperstars(tradeOffer) {
    return Superstars.find({'requestedTradeOfferId': tradeOffer.$loki});
}


export { TradeOffer, getTradeOfferReceiverCompany, getTradeOfferSenderCompany, addTradeOfferOfferedSuperstars,
    removeTradeOfferOfferedSuperstars, getTradeOfferOfferedSuperstars, addTradeOfferRequestedSuperstars,
    removeTradeOfferRequestedSuperstars, getTradeOfferRequestedSuperstars }
